import React from 'react';
import {Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';

const MainTitleComponent = (props) => {
  return (
    <Row className={`${isMobile ? 'w-100 m-0' : ''} `}>
      <Col className='text-center'>
        <Row className={`start-point d-block ${props.styleClass || ''}`}>
          {props.title && <p className='mb-3 confirmationTitle'>{props.title}</p>}
          {props.secondaryTitle && <p className='secondaryTitle'>{props.secondaryTitle}</p>}
        </Row>
      </Col>
    </Row>
  );
};

export default MainTitleComponent;
